<template>
  <van-popup
    :class="['wallet-bottom-popup', layoutClass]"
    round
    v-model="show"
    :position="layoutClass === 'pc' ? 'center' : 'bottom'"
    @close="close"
  >
    <div class="popup-wrapper">
      <sku-info
        :type="type"
        :walletBalance="walletBalance"
        :realPayPrice="realPayPrice"
        :couponPayPrice="couponPayPrice"
        :detailChannelList="detailChannelList"
      />
      <i18n tag="p" class="describe" :path="describeData.path">
        <span :slot="describeData.place" class="describe-weight">{{
          describeData.value
        }}</span>
      </i18n>
      <button @click="click">{{ $t('game.to_bind_account') }}</button>
    </div>
  </van-popup>
</template>
<script>
  import { mapState } from 'vuex'
  import SkuInfo from './SkuInfo'
  import {
    walletRechargePopup,
    walletRechargePopupClick,
  } from '@/pages/Detail/firebase.js'

  export default {
    name: 'wallet-recharge-guide',
    components: {
      SkuInfo,
    },
    // type: active/guide
    props: [
      'type',
      'value',
      'walletBalance',
      'realPayPrice',
      'couponPayPrice',
      'detailChannelList',
    ],
    data() {
      return {
        show: this.value,
      }
    },
    computed: {
      ...mapState(['isDesktop', 'isTurbo', 'selectedSkuInfo', 'gameName']),
      layoutClass() {
        return this.isDesktop ? 'pc' : this.isTurbo ? 'gt' : 'h5'
      },
      describeData() {
        const { type } = this
        if (type === 'guide') {
          return {
            path: 'game.guide_to_bind_wallet_account_2',
            place: 'sku_name',
            value: this.selectedSkuInfo.skuName,
          }
        }
        return {
          path: 'game.guide_to_bind_wallet_account_1',
          place: 'TopLupe',
          value: 'TopLupe',
        }
      },
    },
    watch: {
      value(val) {
        this.show = val
      },
      show(val) {
        if (val) {
          walletRechargePopup(this.gameName, this.type)
        }
      },
    },
    mounted() {},
    methods: {
      close() {
        this.$emit('input', false)
      },
      click() {
        walletRechargePopupClick(this.gameName, this.type)
        this.$emit('active')
      },
    },
  }
</script>

<style scoped lang="scss">
  .wallet-bottom-popup.van-popup {
    width: 100%;
    .popup-wrapper {
      padding: 90px 60px;
      .describe {
        font: 500 36px/48px Manrope-Medium, Manrope;
        color: rgba(153, 153, 153, 0.9);
        margin: 45px 0;
        .describe-weight {
          font-weight: 800;
          color: rgba(0, 0, 0, 0.9);
        }
      }
      button {
        background: #f96000;
        border-radius: 66px;
        width: 100%;
        height: 135px;
        font: 800 45px/45px Manrope-Medium, Manrope;
        color: #ffffff;
      }
    }
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './RechargeGuide_pc.scss';
  }
</style>
